






























































import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Home extends Vue {
    loader = true
    error = null

    get weekArtist() {
        return this.$store.getters['artistModule/getWeekArtist']?this.$store.getters['artistModule/getWeekArtist']:[]
    }
    get topArtist () {
        return this.weekArtist[0]?this.weekArtist[0]:{}
    }
    get weekAlbum() {
        return this.$store.getters['albumModule/getWeekAlbum']?this.$store.getters['albumModule/getWeekAlbum']:[]
    }
    get topAlbum () {
        return this.weekAlbum[0]?this.weekAlbum[0]:{}
    }
    get topTracks() {
            return this.$store.getters['trackModule/getTopTracks']?this.$store.getters['trackModule/getTopTracks']:[]
    }
    get audio () {
        return this.$store.getters['getAudio']
    }

    playAlbum(id: any) {
        this.$store.dispatch('trackModule/fetchAlbumTracks', id).then((response: any) => {
            response[0].tracks.map((track: any) => {
                track['artist_name'] = response[0].artist_name
                track.image = response[0].image
            })
            this.$store.commit('setTracksQueue', response[0].tracks)
            this.$store.commit('playTrack', response[0].tracks[0])
            this.audio.src = response[0].tracks[0].audio
            this.audio.play()
        })
    }

    playSong (track: any, queue: any) {
        this.audio.playbackRate = 1
        this.audio.src = track.audio
        this.$store.commit('setTracksQueue', queue)
        this.$store.commit('playTrack', track)
        this.audio.play();
    }

    created () {
        window.scrollTo(0,0);
        this.$store.dispatch('artistModule/fetchArtistOfTheWeek', 8).then(() => {
            this.loader = false
        }).catch((error: any) => {
            this.loader = false
            this.error = error
        })
        this.$store.dispatch('albumModule/fetchAlbumOfTheWeek', 8)
        this.$store.dispatch('trackModule/fetchTopTracks', 8)
    }
}
